import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'deviationTypeName',
    standalone: false
})
export class DeviationTypeNamePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'Shipment':
        return 'Sending';
      case 'Parcel':
        return 'Kolli';
      default:
        return value;
    }
  }
}
